
	angular.module('qkr').controller('MachinesModalDialogController', MachinesModalDialogController);

	MachinesModalDialogController.$inject = [
		'$uibModal',
		'$uibModalInstance',
		'machinesServices',
		'FormHelper',
		'utils',
		'userAction',
		'editRecord',
		'gettextCatalog',
		'APP_CONSTANT'];

	function MachinesModalDialogController($uibModal, $uibModalInstance,
	                                       machinesServices, FormHelper, utils,
	                                       userAction, editRecord,
	                                       gettextCatalog, APP_CONSTANT) {
		const vm = this;
		new FormHelper(vm);

		const ALLOWED_DISCOUNT_TYPES = [
			APP_CONSTANT.DiscountType.DISCOUNT_AMOUNT,
			APP_CONSTANT.DiscountType.DISCOUNT_PERCENT
		];

		angular.extend(vm, {
			saving: false,
			isNew: false,
			userAction,
			isShowDiscountValue: false,
			AcceptanceDeviceModel: APP_CONSTANT.AcceptanceDeviceModel,
			MachineState: APP_CONSTANT.MachineState,
			DiscountType: APP_CONSTANT.DiscountType,
			modelIds: [],  // available acceptance devices' model ids for selection, including empty string
			models: {}, // map model id to list of acceptance devices' serial numbers
			serials: [],  // available list of {serial numbers and refids} for a selected acceptance device model
			form: {
				acceptanceDeviceModel: '',
				ageRestriction: 0
			},
			isShowOperatingHours: false,
			formFields: [{
				fieldId: 'name',
				fieldLabel: 'Machine name',
				isRequired: true
			}, {
				fieldId: 'machineExtRefId',
				fieldLabel: 'Telemeter Serial Number',
				isRequired: true
			}, {
                fieldId: 'acceptanceDeviceModel',
                fieldLabel: 'Telemeter Device Model',
                isRequired: true
            }, {
				fieldId: 'minPrice',
				fieldLabel: 'Minimum Price',
				isRequired: true,
				type: 'number',
				extraLabel: 'Integer, enter $1.23 as  \'123\''
			}, {
				fieldId: 'maxPrice',
				fieldLabel: 'Maximum Price',
				isRequired: true,
				type: 'number',
				extraLabel: 'Integer, enter $1.23 as  \'123\''
			}, {
				fieldId: 'status',
				fieldLabel: 'Status',
				isRequired: true
			}, {
				fieldId: 'timeOut',
				fieldLabel: 'Timeout (seconds)',
				isRequired: true,
				type: 'number'
			}, {
				fieldId: 'discountType',
				fieldLabel: 'Discount Type',
				isRequired: false
			}, {
				fieldId: 'discountValue',
				isRequired: false
			}, {
				fieldId: 'ageRestriction',
				fieldLabel: 'Age Restriction',
				isRequired: false,
				isShowCheckbox: true,
				isChecked: false
			}, {
				fieldId: 'operatingStartTime',
				fieldLabel: 'Operating Hours',
				isRequired: false,
				isShowCheckbox: true,
				isChecked: false
			}, {
				fieldId: 'operatingEndTime',
				fieldLabel: '',
				isRequired: false
			}]
		});


		vm.removeSerial = function() {
			vm.form.acceptanceDeviceRefId = '';
		};

		vm.getAcceptanceModelDisplayName = (modelId) => {
			if (modelId === '')
				return 'None';

			return APP_CONSTANT.AcceptanceDeviceModel[modelId] || modelId;
		};

		vm.create = (machineForm) => {
			machineForm.$setSubmitted();

			if (machineForm.$invalid) {
				return;
			}

			vm.saving = true;

			(vm.isNew ? machinesServices.create(vm.form) : machinesServices.update(vm.form))
				.then(response => $uibModalInstance.close('done'))
				.catch(response => {
					const message = response.data.exception || response.data.message
						|| 'server error: ' + response.status;
					const title = gettextCatalog.getString((vm.isNew ? "Create" : "Update") + " machine failed");

					showModelOnError(title, message);
				})
				.then(()=> {vm.saving = false;})
				.catch(error => showModelOnError("Unknown error", error))
		};

		const showModelOnError = (title, message) => {
			$uibModal.open({
                template: require('../../templates/common/modalPopup.html'),
				controller: 'CommonModalPopupController',
				windowClass: 'fade',
				backdrop: 'static',
				resolve: {
					title() {
						return gettextCatalog.getString(title);
					},
					message() {
						return gettextCatalog.getString(message);
					}
				}
			}).result.then(noop).catch(noop);
		};

		const noop = () => {};

		vm.cancel = () => {
			$uibModalInstance.close('cancel');
		};

		const updateAgeRestrictionUI = (isChecked) => {
			if (!isChecked) {
				vm.form.ageRestriction = 0;  // Reset the age restriction value
			}
		};

		const updateOperatingHoursUI = (isChecked) => {
			vm.isShowOperatingHours = isChecked;
			if (!isChecked) {
				vm.form.operatingStartTime = null;
				vm.form.operatingEndTime = null;
			}
		};

		const findFieldAndSetChecked = (fieldId, isChecked) => {
			for (let i = 0; i < vm.formFields.length; i += 1) {
				const formField = vm.formFields[i];
				if (formField.fieldId !== fieldId)
					continue;

				formField.isChecked = isChecked;
				return;
			}
		};

		vm.onCheck = (field) => {
			const isChecked = field.isChecked;

			if (field.fieldId === 'ageRestriction')
				updateAgeRestrictionUI(isChecked);
			else if (field.fieldId === 'operatingStartTime')
				updateOperatingHoursUI(isChecked);
		};

		vm.onSelectDiscountType = value => {
			vm.isShowDiscountValue = ALLOWED_DISCOUNT_TYPES.indexOf(value) > -1;
		};

		vm.init = () => {
			vm.isNew = true;
			if (userAction === 'edit') {
				vm.isNew = false;
				const form = angular.extend({}, editRecord);


				/* UI updates based on current values */
				if (editRecord.ageRestriction) {
					updateAgeRestrictionUI(true);
					findFieldAndSetChecked('ageRestriction', true);
				}

				if (ALLOWED_DISCOUNT_TYPES.indexOf(editRecord.discountType) > -1) {
					vm.isShowDiscountValue = true;
				}

				const operatingStartDate = new Date(editRecord.operatingStartTime);
				const operatingEndDate = new Date(editRecord.operatingEndTime);

				form.operatingStartTime = isNaN(operatingStartDate) ? null : operatingStartDate;
				form.operatingEndTime = isNaN(operatingEndDate) ? null : operatingEndDate;

				vm.isShowOperatingHours =
					!utils.isEmpty(editRecord.operatingStartTime) && !utils.isEmpty(editRecord.operatingEndTime);
				findFieldAndSetChecked('operatingStartTime', vm.isShowOperatingHours);

				angular.extend(vm.form, form);
			}
		};

		vm.init();
	}



// WEBPACK FOOTER //
// ./src/controllers/modal/machinesModalDialogController.js